// extracted by mini-css-extract-plugin
export default {"tableHeight":"MenuManagement_tableHeight__mZGXZ","AGDataGrid":"MenuManagement_AGDataGrid__TDnHi","ag-theme-blue":"MenuManagement_ag-theme-blue__sb0ZB"};